<template>
  <el-form ref="ruleForm" :model="form" :rules="rules">
    <el-form-item label="姓名" prop="realname">
      <el-input v-model.trim="form.realname" @input="onInput()" />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submit">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import api from '@/api/account'
export default {
  props: {
    user: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        confirmPassword: ''
      },
      rules: {
        realname: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.form.realname = this.user.realname
  },
  methods: {
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          api.UpdateInfo(this.form).then(response => {
            this.$message({
              message: response.msg,
              type: 'success'
            })
            this.$refs.ruleForm.resetFields()
            this.$store.dispatch('user/getInfo')
          })
        }
      })
    },
    onInput() {
      this.$forceUpdate()
    }
  }
}
</script>
